import Stepper from "./components/Stepper";
import React from "react";
import StepContent from "./components/StepContent";
import { withStyles } from "@material-ui/core";
import { format } from "date-fns";
import { getInitialStepData, getSteps, redirectToIBPlanning } from "./utils";
import withRouter from "../../../routes/withRouter";
import { APP_DATE_FORMAT } from "./constants";
import { getDataWithQueryString, postData } from "./../../../api/componentAPIs";
import { compose } from "recompose";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import { PlanDateContext } from './PlanDateContext';
import { getDefaultIBEtaCutOff } from "./IBBills/utils";
import { checkPlanAlreadyInitialized, getPlanDateIBEtaCutOff } from "./PlanDateForm/utils";
import ETLComponent from "../Common/ETL"
import Events from "../../../utilities/EventEmitter";
import appConstants from "../../../appConstants";
import { getServiceLevelEntries } from "../shared/serviceLevelUtils";
const styles = () => ({
  container: {
    paddingTop: 16,
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 16px)",
  },
});
const enableTraps = false;
class ShipmentSelection extends React.Component {
  constructor(props) {
    super(props);
    this.isPlanDateModified = false;
    this.state = {
      activeStep: this.getInitialStep(),
      stepData: getInitialStepData(enableTraps),
      planDate: null,
      ibEtaCutOff: null,
      serviceLevelList: [],
      initializedDates : [],
      isCompleted : false,
    };
  }

  componentDidMount() {
    this.populateClientCodesData();
    this.loadInitializedPlanDates().then(initializedDates=>{
      if (this.props.router.location?.state?.action === "updateCurrentPlan") {
        const ibEtaCutOff = getPlanDateIBEtaCutOff(
          initializedDates,
          this.props.userData.userProfile.planDate
        );
        this.setState({
          planDate: this.props.userData.userProfile.planDate,
          activeStep: 2, //show IB Bills step directly in case of Update Current Plan action
          ibEtaCutOff: getDefaultIBEtaCutOff({
            ibEtaCutOff,
            planDate: this.props.userData.userProfile.planDate,
            defaultIBEtaCutOffTimeInMinutes:
              this.props.userData?.userProfile?.defaultIbEtaCutOffInMins ?? 0,
          }),
          initializedDates,
        });
      }
      else {
        this.setState({
          initializedDates
        });
      }
    })
  }

  getInitialStep = () => {
    return this.props.router.location?.state?.action === "updateCurrentPlan" ? 2 : 0;
  }

  populateClientCodesData = () => {
    getDataWithQueryString("GetClientCodes").then((response) => {
      if (response && response.status === 200) {
        this.setState({
          // Settings API returns mapped strings; normalize before grids/option builders consume them
          serviceLevelList: getServiceLevelEntries(response.data.serviceLevelList),
        });
      } else {
        this.setState({
          serviceLevelList: [],
        });
      }
    });
  };

  goToNextStep = (selectedShipmentIds) => {
    const { activeStep } = this.state;
    this.setState((prevState) => ({
      activeStep: prevState.activeStep + 1,
      stepData: {
        ...prevState.stepData,
        [activeStep]: selectedShipmentIds,
      },
    }));
  };

  goBack = () => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleSubmit = (lastStepPros, ibEtaCutOff) => {
    
    const selectedShipments = Object.values(this.state.stepData).reduce(
      (acc, value) => {
        return [...acc, ...value];
      },
      [...lastStepPros]
    );
    if(selectedShipments.length===0){
      this.props.enqueueSnackbar('Please select at least one shipment to add to plan', {
        variant: 'info'
      });
      return;
    }
    this.setState({
      isCompleted: true,
    });
    
    const isUpdatePlan = this.checkIfUpdatePlan();
    
    // If current plan is not updated, then only show loader and summary screens.
    !isUpdatePlan &&
      Events.emit(appConstants.Event.SHIPMENT_SELECTION_COMPLETED, {
        showLoader: true,
        planDate: this.state.planDate
      });
      
    const reqData = {
      pros: selectedShipments,
      planDate: format(this.state.planDate, APP_DATE_FORMAT),
      terminalId: this.props.userData.userProfile.terminal.id,
      ibEtaCutOff,
    };
    postData('AddShipmentsToPlan', reqData).then(
      (response) => {
        if (response?.status === 200) {
          if (isUpdatePlan) {
            // In case of Update Plan , no need to show loader and summary screens , therefore directly navigate to ib planning Shipment Managment screen.
            redirectToIBPlanning(this.props.router.navigate)();
            return;
          }
        } else {
          this.handleError(response?.status);
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  };
  
  checkIfUpdatePlan = () => {
    const isPlanInitialized = checkPlanAlreadyInitialized(
      this.state.planDate,
      this.state.initializedDates
    );
    const isUpdateCurrentPlanAction =
      this.props.router.location?.state?.action === 'updateCurrentPlan';
    return isPlanInitialized || (!this.isPlanDateModified && isUpdateCurrentPlanAction);
  };

  handleError = (statusCode) => {
    if (statusCode !== 403) {
      this.props.enqueueSnackbar("Adding shipments to plan failed", {
        variant: "error",
      });
      this.setState({
        isCompleted: false
      });
      Events.emit(appConstants.Event.SHIPMENT_SELECTION_COMPLETED, {showLoader:false})
    }
  }

  handlePlanDateChanged = (planDate, ibEtaCutOff = null) => {
    this.isPlanDateModified = true;
    this.setState((prevState) => ({
      planDate,
      ibEtaCutOff: getDefaultIBEtaCutOff({
        ibEtaCutOff,
        planDate : format(planDate, APP_DATE_FORMAT),
        defaultIBEtaCutOffTimeInMinutes:
          this.props.userData?.userProfile?.defaultIbEtaCutOffInMins ?? 0,
      }),
      activeStep: prevState.activeStep + 1,
    }));
  };

  loadInitializedPlanDates = () => {
    const {
      userData: { userProfile },
    } = this.props;
    return getDataWithQueryString(
      'GetInitializedPlanDates',
      `terminalId=${userProfile.terminal.id}`
    ).then(
      (response) => {
        if (response?.status === 200) {
          return response.data;
        } else {
          return [];
        }
      },
      (err) => []
    );
  };

  isValidFirstPush = ({isFirstPush,planDate}) => {
    return (
      this.state.isCompleted &&
      isFirstPush &&
      format(planDate, APP_DATE_FORMAT) === format(this.state.planDate, APP_DATE_FORMAT)
    );
  }

  render() {
    const { classes } = this.props;
    const planDate = this.state.planDate
      ? format(this.state.planDate, APP_DATE_FORMAT)
      : null;
    const steps = getSteps(enableTraps);
    return (
      <>
        <div className={classes.container}>
          <Stepper activeStep={this.state.activeStep} steps={steps} />
          <PlanDateContext.Provider value={planDate}>
            <StepContent
              step={this.state.activeStep}
              goToNextStep={this.goToNextStep}
              handlePlanDateChanged={this.handlePlanDateChanged}
              glEventHub={this.props.glEventHub}
              goBack={this.goBack}
              selectedShipmentIds={this.state.stepData[this.state.activeStep]}
              handleSubmit={this.handleSubmit}
              enableTraps={enableTraps}
              isLastStep={steps.length - 1 === this.state.activeStep}
              serviceLevelList={this.state.serviceLevelList}
              ibEtaCutOff={this.state.ibEtaCutOff}
              initializedDates={this.state.initializedDates}
              isShipmentSelectionCompleted={this.state.isCompleted}
            />
          </PlanDateContext.Provider>
        </div>
        <ETLComponent isValidFirstPush={this.isValidFirstPush} />
      </>
    );
  }
}

export default compose(
  withUserProfile,
  withSnackbar,
  withStyles(styles),
  withRouter,
)(ShipmentSelection);
